import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {Country} from './country.model';
import {
RequestParameters
} from '../../shared/models/request-parameters/parameter.model';

@Injectable()

export class CountryService {

  constructor(private http: HttpClient) {
  }

  getCountries (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/countries', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message
        });
      }
    );

  }

  postCountry (country: Country) {

    const body = Object.assign({}, country);
    delete body.reference;
    body.monetaryArea = country.monetaryArea.reference;
    if(country.refundOrganization){
      body.refundOrganization = country.refundOrganization.reference
    }
    return this.http.post(GlobalVariable.BASE_API_URL + '/countries', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putCountry (country: Country) {

    const body = Object.assign({}, country);
    delete body.reference;
    body.monetaryArea = country.monetaryArea.reference;
    if(country.refundOrganization){
      body.refundOrganization = country.refundOrganization.reference
    }
    return this.http.put(GlobalVariable.BASE_API_URL + '/country/' + country.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteCountry (country: Country) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/country/' + country.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/parameters/countries/country.service.ts